import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms'
import { AuthService } from '../auth.service'
import { AlertService } from '../../services/alert.service'
import { IResetPassword } from '../../models/IResetPassword'
import { BaseService } from 'app/services/base.service';
import { Router } from '@angular/router';
import { Http } from '@angular/http';


@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  public isRequesting: boolean = false;
  public isSubmitted: boolean = false;
  public model: IResetPassword = { email: '' };
  form: FormGroup;
  constructor(private router: Router,
              private authService: AuthService,
              private formBuilder: FormBuilder,
              private alertService: AlertService,
              private baseService: BaseService
              ) {
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: [null, Validators.required]});

  }

  resetPassword(value, valid: boolean) {
    this.isRequesting = true;
    if (valid) {
      this.authService.resetPassword(this.model)
      .catch(this.baseService.handleError)
      .finally(() => this.isRequesting = false)
      .subscribe(data => {  this.alertService.success("Email with temporary password sent");},
                 error => { this.alertService.error(error)});
    }
  }

}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/account/resetpassword/resetpassword.component.ts